// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3BBmF","label":"Section_label__2UVJk","contentWrap":"Section_contentWrap__71fRz","footer":"Section_footer__3gSIT","footerInner":"Section_footerInner__h6g2w"};